import Wind from "components/icons/Wind";

export const EmptyAgentItemScreen = () => {
  return (
    <div className="t-flex-1 t-min-w-60 t-flex t-flex-col t-justify-center t-items-center t-gap-2 t-h-full">
      <Wind className="t-text-neutral-40" />
      <div className="t-text-body-sm t-text-text-60 t-w-44 t-text-center">
        You have nothing urgent to act upon
      </div>
    </div>
  );
};
